import { render, staticRenderFns } from "./Treejson.vue?vue&type=template&id=221d0d14&scoped=true"
import script from "./Treejson.vue?vue&type=script&lang=js"
export * from "./Treejson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d0d14",
  null
  
)

export default component.exports